import React, { FC } from 'react'
import { IconType } from '../../common/types'

const NucQuestion: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 12 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M7.54688 0.410156H3.75C1.88672 0.410156 0.375 1.92188 0.375 3.78516C0.375 4.38281 0.867188 4.875 1.5 4.875C2.09766 4.875 2.625 4.34766 2.625 3.78516C2.625 3.15234 3.11719 2.66016 3.75 2.66016H7.54688C8.53125 2.66016 9.375 3.46875 9.375 4.45312C9.375 5.15625 8.98828 5.78906 8.28516 6.14062L4.83984 8.14453C4.48828 8.35547 4.3125 8.70703 4.3125 9.09375V10.5C4.3125 11.1328 4.80469 11.625 5.4375 11.625C6.03516 11.625 6.5625 11.1328 6.5625 10.5V9.76172L9.375 8.10938C10.7461 7.40625 11.625 6 11.625 4.45312C11.625 2.20312 9.79688 0.410156 7.54688 0.410156ZM5.4375 13.3125C4.62891 13.3125 4.03125 13.9453 4.03125 14.7188C4.03125 15.5273 4.62891 16.125 5.4375 16.125C6.21094 16.125 6.84375 15.4922 6.84375 14.7188C6.84375 13.9805 6.21094 13.3125 5.4375 13.3125Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucQuestion
